export enum OfflineAction {
	DEFAULT = 0,
	NEW_RECORD = 1,
    UPDATE_RECORD = 2,
    DELETE_RECORD = 3,
}